import waitForNmiCollectJsScript from '@newswebsiteapp/shared/lib/waitForNmiCollectJsScript'
import { getRecaptchaSiteKeyOrThrow, googleRecaptcha_disabled } from '@newswebsiteapp/shared/lib/googleRecaptchaTokenForAction'
import currentUserAttributesValid from '@newswebsiteapp/shared/react/utils/currentUserAttributesValid'

export default function getRootElementAndDataAndKeys({ rootElementId, modalFields_note_show }) {
  const collectJSPromise = waitForNmiCollectJsScript()
  const recaptchaSiteKey = getRecaptchaSiteKeyOrThrow()
  const rootElement = document.querySelector(rootElementId)
  if (!rootElement) { throw new Error(`rootElement not found ${rootElementId}`) }
  // console.log(rootElement)
  const dataFromServer = JSON.parse(rootElement.dataset.json)

  const recaptchaSiteKey_disabled = googleRecaptcha_disabled(recaptchaSiteKey)

  if (!currentUserAttributesValid(dataFromServer.current_user)) { throw new Error('invalid current_user') }

  if (modalFields_note_show === true) {
    dataFromServer.current_user.note = '' // make controlled
  } else if (modalFields_note_show !== false) {
    throw new Error('modalFields_note_show')
  }

  return {
    recaptchaSiteKey,
    recaptchaSiteKey_disabled,
    dataFromServer,
    collectJSPromise,
    rootElement,
  }
}
